// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import CountingBundleTotalRunningAvailability from '../shared/counting-bundle-total-running-availability';
import React from 'react';

function CountingBundleRunningAvailabilityPage () {

    return (
        <AuthenticatedPage className="atp-page atp-counting-bundle-running-availability-page">
            <CountingBundleTotalRunningAvailability bundleAvailability={true} />
        </AuthenticatedPage>
    );

}
CountingBundleRunningAvailabilityPage.displayNAme = 'CountingBundleRunningAvailabilityPage';

export default CountingBundleRunningAvailabilityPage;
